/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { ErrorCode } from 'client-code/channels-service';
import { GuideError } from './GuideError';
import { ErrorTypes } from './ErrorTypes';

export class GuideChannelsError extends GuideError {
    TAG: string = 'GuideChannelsError';

    constructor(message: string, code: string) {
        super(code, message);
        this.message = message;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ErrorCode.Apigw401:
                this.code = ErrorTypes.GUIDE_CHANNELS_APIGW_401_C1101;
                this.type = ErrorCode.Apigw401;
                break;
            case ErrorCode.Apigw4Xx:
                this.code = ErrorTypes.GUIDE_CHANNELS_APIGW_4XX_C1102;
                this.type = ErrorCode.Apigw4Xx;
                break;
            case ErrorCode.Apigw5Xx:
                this.code = ErrorTypes.GUIDE_CHANNELS_APIGW_5XX_C1103;
                this.type = ErrorCode.Apigw5Xx;
                break;
            case ErrorCode.DynamoDbError:
                this.code = ErrorTypes.GUIDE_CHANNELS_DYNAMODB_ERROR_C1104;
                this.type = ErrorCode.DynamoDbError;
                break;
            case ErrorCode.ObjectNotFound:
                this.code = ErrorTypes.GUIDE_CHANNELS_OBJECT_NOT_FOUND_C1105;
                this.type = ErrorCode.ObjectNotFound;
                break;
            case ErrorCode.UnexpectedError:
                this.code = ErrorTypes.GUIDE_CHANNELS_UNEXPECTED_ERROR_C1107;
                this.type = ErrorCode.UnexpectedError;
                break;
            case ErrorCode.BadRequest:
                this.code = ErrorTypes.GUIDE_CHANNELS_BAD_REQUEST_C1108;
                this.type = ErrorCode.BadRequest;
                break;
            default:
                this.code = ErrorTypes.GUIDE_CHANNELS_UNKNOWN_ERROR_C1199;
                this.type = 'GUIDE_CHANNELS_UNKNOWN_ERROR';
        }
    }
}
